export type NutritionalInfoType = {
  calories: number;
  protein: number;
  carbs: number;
  fats: number;
};

interface NutritionInfoContainerType {
  nutritionalInfo: NutritionalInfoType;
}

export const NutritionInfoContainer: React.FC<NutritionInfoContainerType> = ({
  nutritionalInfo,
}) => {
  return (
    <div className="flex h-[72px] items-center justify-center rounded-none bg-black px-6 pb-3 text-3xl text-white md:h-24 md:rounded-b-xl md:px-2 lg:px-6 xl:text-4xl">
      <span className="my-1 inline-block px-2 text-center font-interSemibold xl:px-4">
        {nutritionalInfo?.calories.toFixed(0)}
        <div className="pl-1 font-inter text-base leading-3 lg:text-xl">
          Calories
        </div>
      </span>
      <span className="my-1 inline-block px-2 text-center font-interSemibold xl:px-4">
        {nutritionalInfo?.protein?.toFixed(0)}
        <span className="text-sm md:text-base">g</span>
        <div className="pl-1 font-inter text-base leading-3 lg:text-xl">
          Protein
        </div>
      </span>
      <span className="my-1 inline-block px-2 text-center font-interSemibold xl:px-4">
        {nutritionalInfo?.carbs?.toFixed(0)}
        <span className="text-sm md:text-base">g</span>
        <div className="pl-1 font-inter text-base leading-3 lg:text-xl">
          Carbs
        </div>
      </span>
      <span className="my-1 inline-block px-2 text-center font-interSemibold xl:px-4">
        {nutritionalInfo?.fats?.toFixed(0)}
        <span className="text-sm md:text-base">g</span>
        <div className="pl-1 font-inter text-base leading-3 lg:text-xl">
          Fat
        </div>
      </span>
    </div>
  );
};
